import * as React from 'react';

import { IFRFriend, INITIAL_FRIENDS } from '../fr-friend-list-common';
import { FRFriendListItem } from '../fr-friend-list-item';
import { getModeClass } from 'utils/css';

export class FRFriendListSimple extends React.Component<IFRFriendListSimpleProps> {
    public getInitialFriends(): JSX.Element[] {
        const items: JSX.Element[] = [];
        for (let i: number = 0; i < INITIAL_FRIENDS && i < this.props.friends.length; i++) {
            const friend: IFRFriend = this.props.friends[i];
            const checked: boolean = this.props.listOfCheckedFriends.has(friend.ubiId);

            items.push(
                <FRFriendListItem
                    shouldInheritStyles={this.props.shouldInheritStyles}
                    key={friend.ubiId}
                    env={this.props.env}
                    friend={friend}
                    checked={checked}
                    onCheck={this.props.onCheck}
                />
            );
        }

        return items;
    }

    public render(): JSX.Element {
        const { shouldInheritStyles } = this.props;

        return <div className={getModeClass('sitegen-fr-friend-list-simple', shouldInheritStyles)}>
            {this.getInitialFriends()}
        </div>;
    }
}

export interface IFRFriendListSimpleProps {
    readonly env: string;
    readonly friends: IFRFriend[];
    readonly listOfCheckedFriends: Set<string>;
    readonly onCheck: (ubiId: string) => void;
    readonly shouldInheritStyles: boolean;
}
